(() => {
  if (window.Sn32Motion) { window.Sn32Motion.init(document); return; }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const compact = window.matchMedia('(max-width: 749px)');
  const seen = new WeakSet();
  const pending = new Set();
  const delays = new WeakMap();
  const running = new Map();
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const targets = [
    '.sn17-feature__media', '.sn17-feature__copy',
    '.sn19-choice__intro', '.sn19-choice__card',
    '.sn18-families__list > li',
    '.sn18-facts__heading', '.sn18-facts__intro', '.sn18-facts__grid > div',
    '.sn17-rail .sn17-heading-row',
    '.sn19-faq__intro', '.sn19-faq__items > details',
    '.sn18-story > h1', '.sn18-story__intro', '.sn18-story__figure', '.sn18-story__prose',
    '.sn17-story-split > .sn17-story-copy', '.sn17-story-split > .sn17-story-media',
    '.sn21-product-detail > h2', '.sn21-product-detail__intro', '.sn21-product-detail__media',
    '.sn17-story-views > h2', '.sn17-product-faq > h2',
    '.sn33-value__intro', '.sn33-value__promises > li',
    '.sn33-bundles .sn17-heading-row', '.sn33-bundle',
    '.sn33-catalogue__heading', '.sn33-catalogue__filters',
    '.sn17-collection__heading', '.sn17-collection__toolbar', '.sn17-card',
    '.sn17-buybox > h1', '.sn17-buybox > .sn17-promise',
    '.sn17-product-facts > li', '.sn17-story-view', '.sn33-complements',
    '.sv10-reassure__item', '.sn33-newsletter__band',
    '.sn38-reviews__heading', '.sn38-review'
  ].join(',');
  const all = (scope, selector) => [
    ...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)
  ];
  const play = (node, frames, options = {}) => {
    if (reduced.matches || !node.isConnected || !node.animate || node.contains(document.activeElement)) return;
    const animation = node.animate(frames, { duration: 680, easing: ease, fill: 'backwards', ...options });
    if (!running.has(node)) running.set(node, new Set());
    running.get(node).add(animation);
    const release = () => {
      const animations = running.get(node);
      animations?.delete(animation);
      if (!animations?.size) running.delete(node);
    };
    animation.onfinish = release;
    animation.oncancel = release;
  };
  const reveal = node => play(node, [
    { opacity: .25, translate: `0 ${compact.matches ? 14 : 24}px` },
    { opacity: 1, translate: '0 0' }
  ], { duration: compact.matches ? 580 : 720, delay: delays.get(node) || 0 });
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || !pending.has(entry.target)) return;
      observer.unobserve(entry.target);
      pending.delete(entry.target);
      reveal(entry.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -24px 0px' }) : null;
  const init = scope => {
    if (reduced.matches) return;
    all(scope, '.sn21-hero').forEach(hero => {
      if (seen.has(hero)) return;
      seen.add(hero);
      if (hero.getBoundingClientRect().bottom <= 0) return;
      all(hero, '.sn21-hero__copy > *').forEach((node, index) => {
        play(node, [{ opacity: .3, translate: '0 18px' }, { opacity: 1, translate: '0 0' }],
          { delay: Math.min(index, 4) * 85, duration: 760 });
      });
      const image = hero.querySelector('.sn21-hero__picture img');
      if (image) play(image, [{ opacity: .7, scale: '1.025' }, { opacity: 1, scale: '1' }], { duration: 1100 });
      const cta = hero.querySelector('.sn21-hero__button');
      if (cta) play(cta, [{ opacity: .55 }, { opacity: 1 }], { delay: 300, duration: 680 });
    });
    const groups = new Map();
    all(scope, targets).forEach(node => {
      if (seen.has(node) || (node.matches('.sn17-card') && node.closest('[data-sn33-catalogue]'))) return;
      seen.add(node);
      const index = groups.get(node.parentElement) || 0;
      groups.set(node.parentElement, index + 1);
      delays.set(node, Math.min(index, 4) * 65);
      if (observer) { pending.add(node); observer.observe(node); }
    });
  };
  const cancel = node => {
    running.get(node)?.forEach(animation => animation.cancel());
    running.delete(node);
  };
  const destroy = scope => {
    pending.forEach(node => {
      if (scope === node || scope.contains(node)) {
        observer?.unobserve(node); pending.delete(node);
      }
    });
    running.forEach((animations, node) => {
      if (scope === node || scope.contains(node)) cancel(node);
    });
  };
  const focus = event => {
    running.forEach((animations, node) => { if (node.contains(event.target)) cancel(node); });
    pending.forEach(node => {
      if (node.contains(event.target)) { observer?.unobserve(node); pending.delete(node); }
    });
  };
  const preference = () => {
    if (reduced.matches) {
      running.forEach((animations, node) => cancel(node));
      observer?.disconnect(); pending.clear();
    } else init(document);
  };
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('.sn17-detail, .sn19-faq__items > details')) return;
    const content = details.querySelector('.sn17-detail-content, .sn19-faq__answer');
    if (!content) return;
    cancel(content);
    if (details.open) play(content, [{ opacity: .35, translate: '0 -6px' }, { opacity: 1, translate: '0 0' }], { duration: 320 });
  }, true);
  document.addEventListener('change', event => {
    const chip = event.target.closest?.('.sn17-swatch')?.querySelector('.sn17-swatch-chip');
    if (!chip || !event.target.checked) return;
    cancel(chip);
    play(chip, [{ scale: .85 }, { scale: 1.08, offset: .65 }, { scale: 1 }], { duration: 300 });
  });
  window.Sn32Motion = { init, destroy };
  reduced.addEventListener('change', preference);
  document.addEventListener('focusin', focus);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
